export function generateSeaTrialSeries(data, name, onLegendItemClick) {
  return {
    name: name,
    type: "spline",
    data: data,
    marker: {
      enabled: true,
      radius: 2.5,
      symbol: "circle",
      states: {
        hover: {
          enabled: true,
        }
      }
    },
    animation: false,
    events: {
      legendItemClick: onLegendItemClick
    },
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    visible: false,
  };
}
